<script>
// Name: message-system
import Vue from 'vue'
import Component from './component'
Vue.component(
  'message-system',
  Component
)
</script>



// WEBPACK FOOTER //
// index.vue?2f8832bc